<template>
    <div class="auth-component">
        <div class="select-form" v-if="type != 'reset'">
            <div :class="{ active: type === 'login' }" @click="changeShowFormType('login')">{{ Lang.get('js.login_form.enter') }}</div>
            <div :class="{ active: type === 'register' }" @click="changeShowFormType('register')">
                {{ Lang.get('js.login_form.registr') }}
            </div>
        </div>
        <div v-if="type === 'login'" class="login-form">
            <form method="POST"
                  @submit.prevent="onSubmit(urls['login'])"
                  @keydown="form.errors.clear($event.target.name)">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           name="email"
                           placeholder="E-mail"
                           v-model="form.email"
                    >
                    <span class="text-danger"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')">
                    </span>
                </div>
                <div class="form-group position-relative">

                    <div class="position-relative">
                        <input :type="showPassword ? 'text' : 'password'"
                               class="form-control"
                               name="password"
                               placeholder="Пароль"
                               v-model="form.password">

                        <div class="show-pass pass-show" @click="showPass"></div>
                    </div>
                    <span class="text-danger"
                          v-if="form.errors.has('password')"
                          v-text="form.errors.get('password')">
                    </span>
                </div>
                <div class="form-group">
                    <div class="checkbox">
                        <input type="checkbox" id="remember" name="remember" v-model="form.remember"
                               @click="!form.remember"> <span>{{ Lang.get('js.login_form.remember') }}</span>
                    </div>
                </div>
                <div class="bottom-modal">
                    <div class="form-group position-relative d-flex align-items-center">
                        <button type="submit" :disabled="isDisabled" class="btn my-btn type-1">
                            {{ Lang.get('js.login_form.enter_in') }}
                        </button>
                        <i v-if="loading" class="fa fa-spinner fa-spin fa-3x fa-fw text-success position-absolute"
                           style="font-size: 15px; right: -25px;"></i>
                    </div>

                    <a class="btn-link" title="Забыли пароль?" @click="changeShowFormType('reset')">
                        {{ Lang.get('js.login_form.forgot_password') }}
                    </a>
                </div>
            </form>
        </div>
        <div v-show="type === 'register'" class="register-form">
            <form method="POST"
                  @submit.prevent="onSubmit(urls['register'])"
                  @keydown="form.errors.clear($event.target.name)">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           name="name"
                           :placeholder="Lang.get('js.login_form.name')"
                           v-model="form.name">
                    <span class="text-danger"
                          v-if="form.errors.has('name')"
                          v-text="form.errors.get('name')">
                    </span>
                </div>
                <div class="form-group">
                    <input type="text"
                           class="form-control mobilephone-input-mask"
                           name="phone"
                           placeholder="Телефон"
                           v-model="form.phone">
                    <span class="text-danger"
                          v-if="form.errors.has('phone')"
                          v-text="form.errors.get('phone')">
                    </span>
                </div>
                <div class="form-group">
                    <input type="text"
                           class="form-control email-input-mask"
                           name="email"
                           placeholder="E-Mail"
                           v-model="form.email">
                    <span class="text-danger"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')">
                    </span>
                </div>
                <div class="form-group position-relative">

                    <div class="position-relative">
                        <input :type="showPassword ? 'text' : 'password'"
                               class="form-control"
                               name="password"
                               placeholder="Пароль"
                               v-model="form.password">
                        <span>{{strongPassword}}</span>
                        <div class="show-pass pass-show" @click="showPass"></div>
                    </div>
                    <span class="text-danger"
                          v-if="form.errors.has('password')"
                          v-text="form.errors.get('password')">
                    </span>
                </div>
                <div class="form-group position-relative">
                    <span class="help register-tip" v-if="confirmPassword !== ''" v-html="confirmPassword"></span>
                    <div class="position-relative">
                        <input :type="showConfirm ? 'text' : 'password'"
                               class="form-control"
                               id="password_confirmation"
                               name="password_confirmation"
                               :placeholder="Lang.get('js.login_form.copy_password')"
                               v-model="form.password_confirmation">
                        <div class="show-pass show-pass-confirmation" @click="showConf"></div>
                    </div>
                    <span class="text-danger"
                          v-if="form.errors.has('password_confirmation')"
                          v-text="form.errors.get('password_confirmation')"></span>
                </div>
                <!--                <a class="btn-link" title="Забыли пароль?" @click="changeShowFormType('reset')">-->
                <!--                    Забыли пароль?-->
                <!--                </a>-->
                <div class="form-group position-relative d-flex align-items-center">
                    <button type="submit" :disabled="isDisabled" class="btn my-btn type-1">
                        {{ Lang.get('js.login_form.registr') }}
                    </button>
                    <i v-if="loading" class="fa fa-spinner fa-spin fa-3x fa-fw text-success position-absolute"
                       style="font-size: 15px; right: -25px;"></i>
                </div>
            </form>
        </div>
        <div v-if="type === 'reset'" class="password-reset-form">
            <span class="title-reset-form">{{ Lang.get('js.login_form.new_password') }}</span>

            <form method="POST"
                  @submit.prevent="onSubmit(urls['reset'])"
                  @keydown="form.errors.clear($event.target.name)">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           name="email"
                           placeholder="E-Mail"
                           v-model="form.email"
                    >
                    <span class="text-danger"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')">
                    </span>
                </div>
                <div class="form-group position-relative d-flex align-items-center">
                    <button type="submit" :disabled="isDisabled" class="btn my-btn type-1">
                        {{ Lang.get('js.login_form.send_link') }}
                    </button>
                    <i v-if="loading" class="fa fa-spinner fa-spin fa-3x fa-fw text-success position-absolute"
                       style="font-size: 15px; right: -25px;"></i>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "auth-component",
        data() {
            return {
                form: new Form({
                    name: '',
                    phone: '',
                    password: '',
                    email: '',
                    password_confirmation: '',
                    remember: false,
                }),
                loading: false,
                register: false,
                showPassword: false,
                showConfirm: false,
                type: 'login',
                urls: {
                    'login': '/login',
                    'reset': '/password/reset',
                    'register': '/registerr',
                },
                isDisabled: false,
                confirmPassword: '',
                strongPassword: '',
                Lang,
            }
        },
        methods: {
            onSubmit(url) {
                this.isDisabled = true;
                this.loading = true;

                this.form.submit('post', url).then(res => {
                    console.log(res);
                    location.reload();
                }).catch(rej => {
                    this.loading = false;
                    this.isDisabled = false;
                });
            },
            clearField(fieldName) {
                if (this[fieldName] !== '') {
                    this[fieldName] = '';
                }
            },
            showConf() {
                this.showConfirm = !this.showConfirm;
            },
            showPass() {
                this.showPassword = !this.showPassword;
            },
            changeShowFormType(newType) {
                if (this.loading) {
                    this.loading = false;
                }

                this.type = newType;
                this.form.errors.clear();
                helpers.setInputMask('mobilephone');
            },
            confirmPass() {
                if (this.form.password_confirmation.length > 0) {
                    if (this.form.password === this.form.password_confirmation) {
                        this.confirmPassword = ' совпадает';
                    } else {
                        this.confirmPassword = ' не совпадает';
                    }
                } else {
                    this.clearField('confirmPassword');
                }
            },
            strongPass: _.debounce(
                function () {
                    let pass = this.form.password;
                    if (pass.length >= 8) {
//                        axios({
//                            method: 'post',
//                            url: '/admin/register/strong-password',
//                            data: {pass: pass},
//                            responseType: 'json'
//                        })
//                            .then(response => {
//                                this.strongPassword = response.data.strong;
//                            });
                    } else {
                        this.clearField('strongPassword');
                    }
                }, 500)
        },
        watch: {
            'form.password': function () {
                this.strongPass();
                this.confirmPass();
            },
            'form.password_confirmation': function () {
                this.confirmPass();
                if (this.form.errors.has('password')) {
                    this.form.errors.clear('password');
                }
            },
        },

        mounted() {
            helpers.setInputMask('mobilephone');
        }

    }
</script>






// WEBPACK FOOTER //
// resources/js/components/auth/AuthComponent.vue